import { createAsyncThunk } from '@reduxjs/toolkit';
import { MembershipServices } from 'Services/axios/Membership.Services';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchMemberships = createAsyncThunk(
  'Memberships/fetchMemberships',
  async (filters) => {
    try {
      const response = await MembershipServices.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitMemberships = createAsyncThunk(
  'Memberships/submitMemberships',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('title', data.title);
      formData.append('price', data.price);
      formData.append('gimmick_price', data.gimmick_price);
      formData.append('is_price_bottom', data.is_price_bottom);
      formData.append('subheader_desc', data.subheader_desc);
      formData.append('duration_days', data.duration_days);
      formData.append('is_to_only', data.is_to_only);
      formData.append('is_online', data.is_online);
      formData.append('is_guaranteed', data.is_guaranteed);
      formData.append('is_blacklist_referral', data.is_blacklist_referral);
      formData.append('is_guideline', data.is_guideline);
      data.is_guideline == 1 && formData.append('guideline_description', data.guideline_description);
      formData.append('main_program_id', data.main_program_id);
      data.link && formData.append('link', data.link);
      data?.session_quota && formData.append('session_quota', data?.session_quota);
      data.points.forEach((point, index) => {
        const pdata = { name: point.name, status: point.status };
        if (point.description && point.description.trim() !== '') {
          pdata.description = point.description;
        }
        formData.append(`points[${index}]`, JSON.stringify(pdata));
      });

      let response;
      if (data.isUpdate) {
        response = await MembershipServices.update(data.id, formData);
        toast.success('Membership berhasil diperbarui', {
          position: toast.POSITION.TOP_RIGHT
        });
      } else {
        response = await MembershipServices.create(formData);
        toast.success('Membership berhasil ditambahkan', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteMemberships = createAsyncThunk(
  'Memberships/deleteMemberships',
  async (id) => {
    try {
      const response = await MembershipServices.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return id;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachCourseMemberships = createAsyncThunk(
  'Membership/attachDetachCourseMemberships',
  async (data) => {
    try {
      const formData = new FormData();
      data.courses.forEach((course, index) => {
        formData.append(`course[${index}][id]`, course.value);
      });
      await MembershipServices.attachDetachCourse(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachTryoutMemberships = createAsyncThunk(
  'Membership/attachDetachTryoutMemberships',
  async (data) => {
    try {
      const formData = new FormData();
      data.tryouts.forEach((tryout, index) => {
        formData.append(`tryout[${index}][id]`, tryout.value);
      });
      await MembershipServices.attachDetachTryout(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachUserMemberships = createAsyncThunk(
  'Membership/attachUserMemberships',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('user_id', data.user_id);
      await MembershipServices.attachUser(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const detachUserMemberships = createAsyncThunk(
  'Membership/detachUserMemberships',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('membership_user_id', data.membership_user_id);
      await MembershipServices.detachUser(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const upgradeUserMembership = createAsyncThunk(
  'Membership/upgradeUserMembership',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('user_id', data.user_id);
      formData.append('membership_id_old', data.membership_id_old);
      formData.append('membership_id_new', data.membership_id_new);
      await MembershipServices.upgradeUserMembership(formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const replicateMemberships = createAsyncThunk(
  'Memberships/replicateMemberships',
  async (id) => {
    try {
      const response = await MembershipServices.replicate(id);
      return response;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);